import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
// slices
import dashboardFilterSelectionsReducer from './slices/dashboardFilterSelections';
import checkChartReducer from './slices/check-chart';
import crudFilterReducer from './slices/crud-filters';

// ----------------------------------------------------------------------

const createNoopStorage = () => ({
  getItem(_key: string) {
    return Promise.resolve(null);
  },
  setItem(_key: string, value: any) {
    return Promise.resolve(value);
  },
  removeItem(_key: string) {
    return Promise.resolve();
  },
});

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage();

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const dashboardFilterSelectionsPersistConfig = {
  key: 'dashboardFilterSelections',
  storage,
  keyPrefix: 'redux-',
};

const rootReducer = combineReducers({
  dashboardFilterSelections: persistReducer(
    dashboardFilterSelectionsPersistConfig,
    dashboardFilterSelectionsReducer
  ),
  checkChart: checkChartReducer,
  crudFilters: crudFilterReducer,
});

export { rootPersistConfig, rootReducer };
